import { graphql } from '@/gql';
import type { SendContactUsEmailMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendContactUsEmail = async ({ name, phoneNumber, email, bestCallbackTime, details }: SendContactUsEmailMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      name,
      phoneNumber,
      email,
      bestCallbackTime,
      details,
    },
    mutation: graphql(`
      mutation SendContactUsEmail($name: String!, $phoneNumber: String!, $email: String!, $bestCallbackTime: String!, $details: String!) {
        sendContactUsEmail(name: $name, phoneNumber: $phoneNumber, email: $email, bestCallbackTime: $bestCallbackTime, details: $details)
      }
    `),
  });

  return response.data?.sendContactUsEmail ?? false;
};
